<template>
  <div class="modal">
    <div class="modal-content">
      <button class="modal-button" @click="gotClose(true)">
        <BaseIcon name="window-close" class="icon" />
      </button>
      <h2 class="modal-title" v-if="currentRoute == 'Devices'">{{ 'Add ' + deviceRef }}</h2>
      <h2 class="modal-title" v-else>{{ 'Add ' + currentRoute }}</h2>
      <RawMatForm v-if="currentRoute == 'Raw Materials'" @closeModal="gotClose" />
      <UsersForm v-if="currentRoute == 'Users'" @closeModal="gotClose" />
      <DevicesForm v-if="currentRoute == 'Devices'" @closeModal="gotClose" @gotReference="setReference"/>
      <FlowForm v-if="currentRoute == 'Production Flows'" @closeModal="gotClose" />
      <StepsForm v-if="currentRoute == 'Production Steps'" @closeModal="gotClose" />
    </div>
  </div>
</template>

<script>
import RawMatForm from "@/components/modal-forms/RawMatForm";
import UsersForm from "@/components/modal-forms/UsersForm";
import FlowForm from "@/components/modal-forms/FlowForm";
import StepsForm from "@/components/modal-forms/StepForm";
import DevicesForm from "@/components/modal-forms/DevicesForm";

import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    BaseIcon,
    RawMatForm,
    UsersForm,
    FlowForm,
    StepsForm,
    DevicesForm
  },
  props: {
    title: String,
    page: String
  },
  data() {
    return {
      closeModalHandler: false,
      currentRoute: "",
      deviceRef: "Device",
    }
  },
  created() {
    let that = this;
    document.addEventListener('keyup', function (evt) {
      if (evt.keyCode === 27) {
        that.gotClose(true);
      }
    });
  },
  mounted() {
    this.currentRoute = this.$router.currentRoute.name
    this.deviceRef = "Device"
  },
  methods: {
    gotClose(val) {
      this.$emit('closeModal', val);
    },
    setReference(val){
      if(val != "")
      {
        this.deviceRef = val
      } else {
        this.deviceRef = "Device"
      }  
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";

</style>
